import { reactive, toRaw, watch } from "vue";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { createLoading } from "../../../../utils/loading";
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView,
    onClickReport
} from "../../../../utils/page";
import {has, have} from "../../../../utils/menu-context";
import {
    createButton,
    createButtonActive,
    createButtonArchive,
    createButtonCancel, createButtonCreate,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../utils/button";
import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDeleteAll,
    onClickEdit,
    onClickView
} from "../../../../utils/form";
import { Col, notification, Row } from "ant-design-vue";
import {  setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import {
    callCountry,
    callIntransitMethod,
    createColumns,
    createField
} from "./certificate-request.section";
import {
    addRules,
    clearRulesStartsWith,
    quotaMustNotExceed,
    required,
    requiredWhen,
    validateError,
    validateNotification
} from "../../../../utils/validate";
import { createConditionAction, createConditionForm } from "./certificate-request.condition";
import { flatWhereGroup } from "../../../../utils/search";
import lodash from "lodash";
import { randomUuid } from "../../../../utils/util";
import { createConditionReport } from "./certificate-request.report";
import { openModalReportList } from "../../report/report.logic";
import { openModalForm as openModalCreateRequestChangeHealthCertificateInformation } from "../request-change-certificate-information/request-change-certificate-information.logic"

export const { isLoading, setIsLoading } = createLoading()
export const actionPrefix = 'resource/v1/transaction/certificateRequest'

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form })
export const callSaveAll = ({ form }) => store.dispatch(`${actionPrefix}/saveAll`, { data: form })
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria })
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id })
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id })
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } })
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids })
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids })
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } })
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria })

export const callCertificateRequestStatus = () => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'CERTIFICATE_REQUEST_STATUS' })
export const callFindChildrenByIdAndRequestNo = ({ requestNo, id }) => store.dispatch('resource/v1/transaction/certificateRequest/findChildrenByIdAndRequestNo', { requestNo, id })
export const callMyCompanies = () => store.dispatch('resource/v1/transaction/userCompany/findAllMyCompanies', { userId: store.state.resource.auth.info?.user?.id })
export const callGetSumExportAmount = (data) => store.dispatch('resource/v1/transaction/samplingProduct/getSumExportAmount', { data })
export const callJasperReportByKey = ({ data }) => store.dispatch('resource/v1/master/jasperReport/report', { data } )
export const callRequestChangeInformationTopic = () => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'REQUEST_CHANGE_INFORMATION_TOPIC' })

export const onSearch = ({ props, page }) => {
    const {menuContext} = props
    const sort = page.sort || []
    const where = page.where || []
    const { isTmp, showAllCertRequestAndNullAssignedTo, showCompleteCertRequest, showMyAssigned, isRequestCancel, isRequestChangeInformation} = props
    const whereCondition = [{ name: 'isTmp', type: 'Boolean', operator: '=', value: isTmp }]
    const userInfo = store.state.resource.auth.info?.user;

    if(showAllCertRequestAndNullAssignedTo) {
        whereCondition.push(
            { name: 'isActive', type: 'Boolean', operator: '=', value: true },
            { name: 'refRequestStatus.key', type: 'String', operator: 'in', value: ['Wait'] },
            { name: 'refAssignedTo.id', type: 'UUID', operator: '=', value: null }
        )
    }
    if (showMyAssigned) {
        whereCondition.push(
            { name: 'isActive', type: 'Boolean', operator: '=', value: true },
            { name: 'refRequestStatus.key', type: 'String', operator: 'in', value: ['Pending Review', 'Approve', 'Wait Print'] },
            { name: 'refAssignedTo.username', type: 'String', operator: "=", value: userInfo.username }
        )
    }
    if(showCompleteCertRequest) {
        whereCondition.push(
            { name: 'isActive', type: 'Boolean', operator: '=', value: true },
            { name: 'refRequestStatus.key', type: 'String', operator: 'in', value: ['Printed'] },
            { name: 'isPrinted', type: "Boolean", operator: "=", value: true }
        )
    }

    if(isRequestCancel || isRequestChangeInformation ){
        const departmentIds = []
        if(userInfo.refDepartment?.refParent) {
            departmentIds.push(userInfo.refDepartment?.refParent?.id)
        }
        departmentIds.push(userInfo.refDepartment?.id)

        if (has({ menuContext, key: 'forCertificateApprover' })) {
            whereCondition.push(
                { name: 'refRequestStatus.key', type: 'String', isNot: true, operator: 'in', value: ['Draft', 'Cancel', 'Printed']},
                { name: 'refAssignedTo.username', type: "String", operator: "=", value: userInfo?.username }
            )
        }
        if (has({ menuContext, key: 'forCertificateSigner' })) {
            whereCondition.push(
                { name: 'refRequestStatus.key', type: 'String', isNot: true, operator: 'in', value: ['Draft', 'Cancel', 'Printed']},
                { openBucket: true, name: 'refAssignedTo.refDepartment.id', type: 'UUID', operator: 'in', value: departmentIds  },
                { closeBucket: true, logic: "OR", name: 'refAssignedTo.refDepartment.refParent.id', type: 'UUID', operator: 'in', value: departmentIds  }
            )
        }
    }

    setIsLoading(true)
    window.onSearch?.({ page })
    const promise = [callMyCompanies(), callRequestChangeInformationTopic()]
    return Promise.all(promise)
        .then((promised) => {
            const requestChangeInformationKey = promised[1].filter(d => d.key == "Change Information").map(d2 => d2.key)
            const requestCancelKey = promised[1].filter(d => d.key == "Cancel").map(d2 => d2.key)
            const requestChangeWhere = isRequestCancel ? [{ name: 'refRequestChangeInformationTopic.key', type: 'String', operator: 'in', value: requestCancelKey }]
                : isRequestChangeInformation ? [{ name: 'refRequestChangeInformationTopic.key', type: 'String', operator: 'in', value: requestChangeInformationKey }] : [];

            return callSearch({
                criteria: {
                    ...page,
                    data: [],
                    where: [...where, ...whereCondition, ...createWhereRole({ props, promised }), ...requestChangeWhere],
                    sort: [...sort, { name: 'updateDate', type: 'DESC' }]
                }
            })
        })
        .then(page => state.page = page)
        .finally(() => setIsLoading(false))
}

export const createWhereRole = ({ props, promised }) => {
    const { menuContext, isTmp, isAllModels } = props
    const whereGroup = []
    const companies = promised?.length ? promised[0] : []
    const userInfo = store.state.resource.auth.info?.user;
    const departmentIds = []
    if(userInfo.refDepartment?.refParent) {
        departmentIds.push(userInfo.refDepartment?.refParent?.id)
    }
    departmentIds.push(userInfo.refDepartment?.id)

    if (has({ menuContext, key: 'canViewAll' })) {
        return [];
    }

    if (has({ menuContext, key: 'canViewDepartment' })) {
        whereGroup.push([
            { openBucket: true, name: 'refDepartment.id', type: 'UUID', operator: 'in', value: departmentIds  },
            { closeBucket: true, logic: "OR", name: 'refDepartment.refParent.id', type: 'UUID', operator: 'in', value: departmentIds  }
        ])
    }

    if (has({ menuContext, key: 'canViewOwner' })) {
        whereGroup.push([
            { name: 'refAssignedTo.username', type: "String", operator: "=", value: userInfo?.username  },
        ])
    }

    if (has({ menuContext, key: 'forCompany' })) {
        const arrTmp = [{ name: 'refCompany.id', type: 'UUID', operator: 'in', value: companies.map(d=>d.id) }]
        if(!isTmp) {
            arrTmp.push({ name: 'isAllModels', type: 'Boolean', operator: '=', value: isAllModels })
        }
        whereGroup.push(arrTmp)
    }

    if (has({ menuContext, key: 'forCertificateApprover' })) {
        whereGroup.push([
            { name: 'isActive', type: 'Boolean', operator: '=', value: true },
            { name: 'refAssignedTo.username', type: "String", operator: "=", value: userInfo?.username  },
        ])
    }

    if (has({ menuContext, key: 'forCertificateSigner' })) {
        whereGroup.push([
            { name: 'isActive', type: 'Boolean', operator: '=', value: true },
            { openBucket: true, name: 'refAssignedTo.refDepartment.id', type: 'UUID', operator: 'in', value: departmentIds  },
            { closeBucket: true, logic: "OR", name: 'refAssignedTo.refDepartment.refParent.id', type: 'UUID', operator: 'in', value: departmentIds  }
        ])
    }
    return flatWhereGroup({ where: whereGroup, logic: 'OR' })
}

export const createSearchOneCriteriaParent = ({ id }) => {
    return {
        select: ['**'],
        page: 0,
        size: 1,
        where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
    }
}

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: [
                '**', 'refCompany.refFactoryAddrEn.**', 'refAssignedTo.**',
                'refAssignedTo.refDepartment.refParent.*'
            ],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: [
                { name: 'attachments', select: ['*'], page: 0, size: 1000000},
                { name: 'signatures', select: ['*'], page: 0, size: 100, sort: [{ name: "updateDate", type: "DESC" }]},
                { name: 'farmLocations', select: ['**', 'refParent.**'], page: 0, size: 1000000},
                { name: 'aquaticScientificNames', select: ['**', 'refParent.**'], page: 0, size: 1000000 },
                { name: 'certificateProducts',
                    select: [
                        '**',
                        'refCompanyProduct.refProduct.*',
                        'refCompanyProduct.refProduct.refProductType.*',
                        'refSamplingProduct.*',
                        'refSamplingProduct.refExportAmountUnit.*',
                        'refSamplingProduct.refCompanyProduct.*',
                        'refSamplingProduct.refCompanyProduct.refProduct.*',
                        'refSamplingProduct.refCompanyProduct.refProduct.refProductType.*',
                        'refSamplingProduct.refCountry1.refCountry.*',
                        'refSamplingProduct.refCountry2.refCountry.*',
                        'refParent.**',
                        'refParent.refCompanyProduct.refProduct.*',
                        'refParent.refCompanyProduct.refProduct.refProductType.*',
                        'refParent.refSamplingProduct.*',
                        'refParent.refSamplingProduct.refExportAmountUnit.*',
                        'refParent.refSamplingProduct.refCompanyProduct.*',
                        'refParent.refSamplingProduct.refCompanyProduct.refProduct.*',
                        'refParent.refSamplingProduct.refCompanyProduct.refProduct.refProductType.*',
                        'refParent.refSamplingProduct.refCountry1.refCountry.*',
                        'refParent.refSamplingProduct.refCountry2.refCountry.*',
                    ],
                    page: 0,
                    size: 1000000,
                },
                { name: 'children', select: ['**'], page: 0, size: 1000000},
            ]
        }
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: []
        }
    }
}

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error })
            throw error
        });
}

export const createFormTitle = ({ data }) => {
    const { modelRef } = data.useForm
    return modelRef.id ? `${modelRef.requestNo} (${modelRef.refRequestStatus?.value})` : i18n.global.t('button.create')
}

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true)
    const { form, routerPrefix, /*menuContext*/ } = props
    const { id, useForm } = data
    const { modelRef } = useForm
    let promise = null
    if (form) {
        promise = Promise.resolve({ data: [form] })
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, id })})
    } else {
        promise = Promise.resolve({ data: [modelRef] })
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => {
            const promises = [
                !modelRef.refCompany ? callMyCompanies() : null,
                !modelRef.refSourcePortCountry ? callCountry({}) : null,
                !modelRef.refIntransitMethod ? callIntransitMethod({}) : null,
                 modelRef?.refParent?.id ? callSearch({ criteria: createSearchOneCriteriaParent({ props, id: modelRef.refParent?.id })}) : null,
            ];
            return Promise.all(promises)
        })
        .then((res) => {
            const myCompanies = res[0];
            const countries = res[1];
            const intransitMethods = res[2];
            const refParentPage = res[3];
            modelRef.refParent = refParentPage?.data?.[0]

            if(!modelRef.refIntransitMethod) { modelRef.refIntransitMethod = intransitMethods.filter(d => ['N'].includes(d.key))?.[0]}

            if(!modelRef.requester) { modelRef.requester = store.state.resource.auth.info?.user?.firstNameTh }

            if (!modelRef.refCompany && !myCompanies?.length) {
                notification['error']({ message: i18n.global.t("views.error.404.title") });
            }

            if (!modelRef.refCompany && myCompanies?.length > 0) {
                modelRef.refCompany = myCompanies[0]
                modelRef.refDepartment = myCompanies[0].refDepartment
                modelRef.producerPlantName = modelRef.refCompany?.nameEn

                const addrNo = modelRef?.refCompany?.refFactoryAddrEn?.addrNo ? modelRef?.refCompany?.refFactoryAddrEn?.addrNo : ""
                const addrRoom = modelRef?.refCompany?.refFactoryAddrEn?.addrRoom;
                const addrBuilding = modelRef?.refCompany?.refFactoryAddrEn?.addrBuilding;
                const addrFloor = modelRef?.refCompany?.refFactoryAddrEn?.addrFloor;
                const addrVillage = modelRef?.refCompany?.refFactoryAddrEn?.addrVillage;
                const addrMoo = modelRef?.refCompany?.refFactoryAddrEn?.addrMoo;
                const addrSoi = modelRef?.refCompany?.refFactoryAddrEn?.addrSoi;
                const addrRoad = modelRef?.refCompany?.refFactoryAddrEn?.addrRoad;
                const addrTambonEn = modelRef?.refCompany?.factoryTambonEn;
                const addrAmphurEn = modelRef?.refCompany?.refFactoryAddrEn?.refAmphur?.nameEn;

                // 17/4 Village No.5 Bamroongrat Road, Pibulsongkram Sub-district, Muang District, Bangkok, 10400
                // 120/12 Moo 1 Soi 1 Sub-district Khlong Toei District Khlong Toei Province Bangkok 10110
                // "Room ", "Building ", "Floor ", "Village ", "Moo ", "Soi ", "Road ", "Sub-district ", "District ", "Province ");

                let address = "";
                // if (addrNo) { address += addrNo }
                // if (addrRoom) { address += ", Room " + addrRoom }
                // if (addrBuilding) { address += ", Building " + addrBuilding }
                // if (addrFloor) { address += ", Floor " + addrBuilding }
                // if (addrVillage) { address += ", " + addrVillage + " Village"}
                // if (addrMoo) { address += ", Moo " + addrMoo }
                // if (addrSoi) { address += ", Soi " + addrSoi }
                // if (addrRoad) { address += ", " + addrRoad + " Road" }
                // if (addrTambonEn) { address += ", Sub-district " + addrTambonEn }
                // if (addrAmphurEn) { address += ", District " + addrAmphurEn }


                if (addrNo) { address += addrNo }
                if (addrRoom) { address += "," + addrRoom }
                if (addrBuilding) { address += "," + addrBuilding }
                if (addrFloor) { address += "," + addrBuilding }
                if (addrVillage) { address += "," + addrVillage}
                if (addrMoo) { address += "," + addrMoo }
                if (addrSoi) { address += "," + addrSoi }
                if (addrRoad) { address += "," + addrRoad }
                if (addrTambonEn) { address += "," + addrTambonEn }
                if (addrAmphurEn) { address += "," + addrAmphurEn }


                modelRef.producerAddress = address
                modelRef.refProducerProvince = modelRef.refCompany?.refFactoryAddrEn?.refProvince
                modelRef.producerPostcode = modelRef.refCompany?.refFactoryAddrEn?.postCode
                modelRef.producerPhoneNo = modelRef.refCompany?.refFactoryAddrEn?.phone
                modelRef.refReportProducerAddressCase = !modelRef.refReportProducerAddressCase ? modelRef?.refCompany?.refReportAddressCase : modelRef.refReportProducerAddressCase
                modelRef.refReportExporterAddressCase = !modelRef.refReportExporterAddressCase ? modelRef?.refCompany?.refReportAddressCase : modelRef.refReportExporterAddressCase
            }

            if (!modelRef.refSourcePortCountry && countries) {
                modelRef.refSourcePortCountry = countries.filter(d => ['Thailand'].includes(d.nameEn))[0]
            }

            /*  ย้ายไป Stamp ตอนอนุมัติแทน */
            // if(has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext: menuContext, key: 'forCertificateSigner' })) {
            //     if(![undefined, "Draft", "Wait"].includes(modelRef.refRequestStatus?.key)){
            //         modelRef.certificateApprovalDate = modelRef.certificateApprovalDate ? modelRef.certificateApprovalDate
            //             : modelRef.isTmp ? modelRef?.refParent?.certificateApprovalDate : modelRef.loadingDate
            //     }
            // }
            modelRef.isoSourcePortCountry = !modelRef.isoSourcePortCountry ? modelRef?.refSourcePortCountry?.isoTwoDigit?.[0]?.code : modelRef.isoSourcePortCountry

        })
        .then(() => {
            // callGetSumExportAmount each certificateProduct
            if ((modelRef?.refRequestStatus && modelRef.refRequestStatus?.key !== 'Draft') || !modelRef.isAllModels) { return null }
            const promises = modelRef.certificateProducts?.map(d=>{
                const certificateProductId = d.refParent?.id ? d.refParent?.id : d.id
                const data = { certificateProductId , samplingProductId: d.refSamplingProduct?.id }
                return callGetSumExportAmount(data);
            })
            return Promise.all(promises)
        })
        .then((res) => {
            if (res?.length) {
                modelRef.certificateProducts?.forEach(d=>{
                    if (d.refSamplingProduct) {
                        const samplingProductId = d.refSamplingProduct?.id
                        const exported = res?.find(d => d.samplingProductId === samplingProductId)?.sum || 0
                        const balanceAmount = d.refSamplingProduct.exportAmount - exported;
                        if (d.balanceAmount !== balanceAmount) {
                            d.balanceAmount = balanceAmount;
                            d.isSave = true;
                        }
                    }
                })
            }
        })
        .then(() => initByRole({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] }, routerPrefix }))
        .finally(() => setIsLoading(false))
}


export const createFormHealthCert = ({ props }) => {
    return {
        refCompany: null,
        requestNo: null,
        requester: null,
        requestDate: null,
        certificateNo : null,
        certificateDate : null,
        editCertificateDate : null,
        refReportProducerAddressCase: null,
        producerPlantName: null,
        producerAddress: null,
        producerPostcode: null,
        producerPhoneNo: null,
        refReportExporterAddressCase: null,
        exporterName: null,
        exporterAddress: null,
        exporterPostcode: null,
        exporterPhoneNo: null,
        consigneeName: null,
        consigneeAddress: null,
        consigneeCity: null,
        consigneePostcode: null,
        consigneePhoneNo: null,
        commodityName: "",
        packagingSize: null,
        qty: null,
        netWeight: null,
        grossWeight: null,
        vehicleName: null,
        referenceDocNo: null,
        sourcePortCity: null,
        // fob: null,
        loadingDate : null,
        shipmentDate: null,
        productCodeNo: null,
        containerNo: null,
        sealNo:null,
        temperatureValue: null,
        refDepartment: null,
        additionalVouchTextRemark: null,
        replacementRemark: null,
        remark: null,
        refExportCountry: null,
        refProducerProvince: null,
        refExporterProvince: null,
        refRequestStatus : null,
        refTransportMode : null,
        refIntransitMethod: null,
        refTransportTemperature: null,
        refRequestForm: null,
        refIntransitForm: null,
        shippingMask: null,
        destinationPort: null,
        destinationViaPort: null,
        refDestinationViaCountry: null,
        refSourcePortCountry: null,
        refDestinationPortCountry: null,
        refExportAmountUnit: null,
        isAllModels: props?.isAllModels,
        refRequestType: null,
        attachments: [],
        signatures: [],
        aquaticScientificNames: [],
        certificateProducts: [],
        typeOfTreatment: null,
        hsCode: null,
        regionOfOrigin: null,
        approvalZone: null,
        nameOfOperator: null,
        addressOfOperator: null,
        cityOfOperator: null,
        postcodeOfOperator: null,
        phoneNoOfOperator: null,
        namePlaceOfDestination: null,
        addressPlaceOfDestination: null,
        accompanyingDocumentType: null,
        accompanyingDocumentNo: null,
        isCanningIndustry: null,
        isHumanConsumption: null,
        batchNo: null,
        isFinalConsumer: null,
        manufacturingDate: null,
        expiredDate: null,
        healthCertificateNo: null,
        healthCertificateDate: null,
        refFromCountryOfOrigin: null,
        isAquaculture: null,
        isWildCaught: null,
        refIsAquaculture: null,
        aquacultureArea: null,
        refIsWildCaught: null,
        catchArea: null,
        catchVesselNameAndNo: null,
        isProcessedDairyProduct: null,
        refProducedInTheCountry: null,
        approvalNo: null,
        refProductOn: null,
        productOnDate: null,
        productOnBetweenDate1: null,
        productOnBetweenDate2: null,
        refApprovalCountry: null,
        freezingDate: null,
        refHumanConsumption: null,
        farmLocations: [],
        refParent: null,
        children: [],
        isTmp: props?.isTmp,
        refAssignedTo: null,
        requestChangeInformationNo: null,
        refRequestChangeInformationTopic: null,
        hologramNo1: null,
        hologramNo2: null,
        isPrinted: false,
        certificateApprovalDate: null,
        approverRemark: null,
        correctionDetails: null,
        refCanceledBy: null,
        canceledRemark: null,

        refCountryOfOriginOfRawMaterial: null,
        // refProcessingType: null,
        refCharacterOfProductiveWaterArea: null,
        aquacultureFarmNameAndRegistrationNo: null,
        fishVesselDetail: null,
        fishVesselFactoryDetail: null,
        transportVesselDetail: null,
        coldStorageMaterialDetail: null,
        coldStorageProductDetail: null,
        lotNoOfProduct: null,
        flightNo: null,
        otherTransportMean: null,
        imsocReference: null,
        isLiveAquaticAnimalForHumanConsumption: null,
        isFurtherProcessing: null,
        isForInternalMarket: null,
        coldStore: null,
        refOperatorCountry: null,
        refPlaceOfDestinationCountry: null,
        isoSourcePortCountry: null,
        isoExportCountry: null,
        isoOperatorCountry: null,
        isoPlaceOfDestinationCountry: null,
        runningNo: null,
        regionOfDestination: null,
        approvalZone2: null,
        regNoPlaceOfDestination: null,
        refAccompanyingDocumentCountry: null,
        isoAccompanyingDocumentCountry: null,
        countryOfOriginOfRawMaterial: null,
        slaughterhouse: null,
        dairyProducingCountries: null,
        euApprovalNo: null,
        isProduceDairyPeriod: null,
        dairyProduceStartDateStr: null,
        dairyProduceEndDateStr: null,
        eggOriginCountries: null,
    }
}

export const createRules = ({ key }) => {
    const prefix = key ? `${key}.` : ''
    return {
        [`${prefix}refCompany`]: [required],
        [`${prefix}refDepartment`]: [required],
        [`${prefix}refExportCountry`]: [required],
        [`${prefix}isoExportCountry`]: [required],
        [`${prefix}refRequestForm`]: [required],
        [`${prefix}producerPlantName`]: [required],
        [`${prefix}producerAddress`]: [required],
        [`${prefix}refProducerProvince`]: [required],
        [`${prefix}exporterName`]: [required],
        [`${prefix}exporterAddress`]: [required],
        [`${prefix}refExporterProvince`]: [required],
        [`${prefix}consigneeName`]: [required],
        [`${prefix}consigneeAddress`]: [required],
        [`${prefix}netWeight`]: [required],
        // [`${prefix}grossWeight`]: [required],
        [`${prefix}refTransportMode`]: [required],
        [`${prefix}sourcePortCity`]: [required],
        [`${prefix}destinationPort`]: [required],
        [`${prefix}loadingDate`]: [required],
        [`${prefix}shipmentDate`]: [required],
        [`${prefix}refTransportTemperature`]: [required],
        // [`${prefix}fob`]: [required],
        [`${prefix}refReportProducerAddressCase`]: [required],
        [`${prefix}refReportExporterAddressCase`]: [required],
    }
}

export const initByRole = ({ props, data, key }) => {
    const { menuContext, viewOnly } = props
    const { useForm } = data
    const { modelRef, initialModel } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const initModel = key ? lodash.get(initialModel, key) : initialModel
    const prefix = key ? `${key}.` : ''
    // addRules({ useForm, modelRef, key: `${prefix}refIntransitForm`, rules: [requiredWhen({ when: () => ['I', 'V'].includes(model.refIntransitMethod?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}packagingSize`, rules: [requiredWhen({ when: () => model.isAllModels == false && props.isAllModels == false  })] })
    addRules({ useForm, modelRef, key: `${prefix}destinationViaPort`, rules: [requiredWhen({ when: () => ['I', 'V'].includes(model.refIntransitMethod?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}refDestinationViaCountry`, rules: [requiredWhen({ when: () => ['I', 'V'].includes(model.refIntransitMethod?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}temperatureValue`, rules: [requiredWhen({ when: () => ['C', 'F'].includes(model.refTransportTemperature?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}commodityName`, rules: [requiredWhen({ when: () => model.certificateProducts.length > 0 })] })
    addRules({ useForm, modelRef, key: `${prefix}qty`, rules: [requiredWhen({ when: () => model.certificateProducts.length > 0 })] })
    addRules({ useForm, modelRef, key: `${prefix}refExportAmountUnit`, rules: [requiredWhen({ when: () => model.certificateProducts.length > 0 })] })

    addRules({ useForm, modelRef, key: `${prefix}typeOfTreatment`,
        rules: [requiredWhen({ when: () => ['UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                        , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                        , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                        , 'EST', 'ROU', 'HRV', /*'dof_health_cert',*/ 'bosnia_and_herzegovina', 'serbia', 'turkey', 'china_export', 'CHN-Export', 'israel', 'north_macedonia', 'malaysia', 'montenegro', 'morocco', 'new_caledonia'].includes(model.refRequestForm?.key)
                    || ['UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                        , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                        , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                        , 'EST', 'ROU', 'HRV', /*'dof_health_cert',*/ 'bosnia_and_herzegovina', 'serbia', 'turkey', 'china_export', 'CHN-Export', 'israel', 'north_macedonia', 'malaysia', 'montenegro', 'morocco', 'new_caledonia'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}hsCode`,
        rules: [requiredWhen({ when: () => ['UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                        , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                        , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                        , 'EST', 'ROU', 'HRV', 'bosnia_and_herzegovina', 'serbia', 'turkey', 'brazil_fishery', 'Composite Food', 'korea_fishhead', 'north_macedonia', 'malaysia', 'montenegro', 'new_zealand_bivalue', 'saudi_arabia'].includes(model.refRequestForm?.key)
                    || ['UK', 'EU', 'saudi_arabia', 'new_caledonia', 'north_macedonia' ,'malaysia', 'israel', 'ukraine', 'montenegro', 'turkey'
                        , 'bosnia_and_herzegovina', 'argentina', 'russia', 'CYP', 'NLD', 'BEL', 'LUX', 'FRA', 'DEU', 'AUT', 'ITA'
                        , 'ESP', 'SWE', 'PRT', 'FIN', 'CZE', 'GRC', 'BGR', 'DNK', 'HUN', 'LVA', 'LTU', 'MLT', 'POL', 'SVK', 'SVN'
                        , 'EST', 'ROU', 'HRV', 'bosnia_and_herzegovina', 'serbia', 'turkey', 'brazil_fishery', 'Composite Food', 'korea_fishhead', 'north_macedonia', 'malaysia', 'montenegro', 'new_zealand_bivalue', 'saudi_arabia'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}regionOfOrigin`,
        rules: [requiredWhen({ when: () => ['UK', 'Composite Food', 'new_zealand_bivalue'].includes(model.refRequestForm?.key) || ['UK', 'Composite Food', 'new_zealand_bivalue'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}approvalZone`,
        rules: [requiredWhen({ when: () => ['UK', 'Composite Food', 'new_zealand_bivalue'].includes(model.refRequestForm?.key) || ['UK', 'Composite Food', 'new_zealand_bivalue'].includes(model.refIntransitForm?.key) })] })

    addRules({ useForm, modelRef, key: `${prefix}manufacturingDate`,
        rules: [requiredWhen({ when: () => ['argentina', 'azerbaijan', 'russia', 'china_export', 'CHN-Export', 'french_polynesia', 'israel', 'korea_fishhead', 'morocco', 'saudi_arabia'].includes(model.refRequestForm?.key) || ['argentina', 'azerbaijan', 'russia', 'china_export', 'CHN-Export', 'french_polynesia', 'israel', 'korea_fishhead', 'morocco', 'saudi_arabia'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}expiredDate`,
        rules: [requiredWhen({ when: () => ['argentina', 'french_polynesia', 'israel', 'morocco', 'saudi_arabia'].includes(model.refRequestForm?.key) || ['argentina', 'french_polynesia', 'israel', 'morocco', 'saudi_arabia'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}healthCertificateNo`,
        rules: [requiredWhen({ when: () => ['australia_salmonid', 'new_zealand_salmon'].includes(model.refRequestForm?.key) || ['australia_salmonid', 'new_zealand_salmon'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}healthCertificateDate`,
        rules: [requiredWhen({ when: () => ['australia_salmonid', 'new_zealand_salmon'].includes(model.refRequestForm?.key) || ['australia_salmonid', 'new_zealand_salmon'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}refFromCountryOfOrigin`,
        rules: [requiredWhen({ when: () => ['australia_salmonid', 'new_zealand_salmon'].includes(model.refRequestForm?.key) || ['australia_salmonid', 'new_zealand_salmon'].includes(model.refIntransitForm?.key) })] })

    addRules({ useForm, modelRef, key: `${prefix}refIsAquaculture`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}refIsWildCaught`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}aquacultureArea`,
        rules: [requiredWhen({ when: () =>  ["Yes", "No"].includes(model.refIsAquaculture?.key)})] })
    addRules({ useForm, modelRef, key: `${prefix}catchArea`,
        rules: [requiredWhen({ when: () => ["Yes", "No"].includes(model.refIsWildCaught?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}refProducedInTheCountry`,
        rules: [requiredWhen({ when: () => ['Composite Food'].includes(model.refRequestForm?.key) || ['Composite Food'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}approvalNo`,
        rules: [requiredWhen({ when: () => ['Composite Food'].includes(model.refRequestForm?.key) || ['Composite Food'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}refProductOn`,
        rules: [requiredWhen({ when: () => ['Composite Food'].includes(model.refRequestForm?.key) || ['Composite Food'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}productOnDate`,
        rules: [requiredWhen({ when: () => model.refProductOn?.key == "D" })] })
    addRules({ useForm, modelRef, key: `${prefix}productOnBetweenDate1`,
        rules: [requiredWhen({ when: () => model.refProductOn?.key == "DB"  })] })
    addRules({ useForm, modelRef, key: `${prefix}productOnBetweenDate2`,
        rules: [requiredWhen({ when: () => model.refProductOn?.key == "DB" })] })
    addRules({ useForm, modelRef, key: `${prefix}refApprovalCountry`,
        rules: [requiredWhen({ when: () => ['Composite Food'].includes(model.refRequestForm?.key) || ['Composite Food'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}freezingDate`,
        rules: [requiredWhen({ when: () => ['french_polynesia'].includes(model.refRequestForm?.key) || ['french_polynesia'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}refHumanConsumption`,
        rules: [requiredWhen({ when: () => ['israel'].includes(model.refRequestForm?.key) || ['israel'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}farmLocations`,
        rules: [requiredWhen({ when: () => ['new_zealand_tilapia_or_catfish'].includes(model.refRequestForm?.key) || ['new_zealand_tilapia_or_catfish'].includes(model.refIntransitForm?.key) })] })

    addRules({ useForm, modelRef, key: `${prefix}countryOfOriginOfRawMaterial`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}refCharacterOfProductiveWaterArea`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}aquacultureFarmNameAndRegistrationNo`,
        rules: [requiredWhen({ when: () => ["Yes", "No"].includes(model.refIsAquaculture?.key)})] })
    addRules({ useForm, modelRef, key: `${prefix}fishVesselDetail`,
        rules: [requiredWhen({ when: () => ["Yes", "No"].includes(model.refIsWildCaught?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}fishVesselFactoryDetail`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}transportVesselDetail`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}coldStorageMaterialDetail`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}coldStorageProductDetail`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}lotNoOfProduct`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}flightNo`,
        rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })
    addRules({ useForm, modelRef, key: `${prefix}otherTransportMean`,
         rules: [requiredWhen({ when: () => ['china_export', 'CHN-Export'].includes(model.refRequestForm?.key) || ['china_export', 'CHN-Export'].includes(model.refIntransitForm?.key) })] })

    if (has({ menuContext, key: 'forCompany' })) {
        if ([undefined, 'Draft', 'Reject'].includes(initModel.refRequestStatus?.key)) {
            addRules({ useForm, modelRef, key: `${prefix}correctionDetail`, rules: [requiredWhen({ when: () => props.isTmp == true || model.isTmp == true })] })
        }
    }
    // if (has({ menuContext, key: 'forCertificateApprover' })) {
    //     addRules({ useForm, modelRef, key: `${prefix}certificateApprovalDate`, rules: [requiredWhen({ when: () => ['Approve'].includes(modelRef.refRequestStatus?.key) })] })
    // }

    if(!viewOnly) {
        createRulesCertificateProducts({ props, data, key })
        watch(
            () => model.certificateProducts?.filter(d=>d.balanceAmount != null)?.length,
            () => createRulesCertificateProducts({ props, data, key }),
            { flush: "post" }
        );
    }
}

export const createRulesCertificateProducts = ({ data, key }) => {
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''

    clearRulesStartsWith({ useForm, key: `${prefix}certificateProducts` });
    model?.certificateProducts?.map((certificateProduct, index) => {
        if (!certificateProduct.isDelete && certificateProduct.balanceAmount != null) {
            const balanceAmount = certificateProduct.balanceAmount;
            addRules({ useForm, modelRef, key: `${prefix}certificateProducts.${index}.exportAmount`, rules: [required, quotaMustNotExceed(balanceAmount < 0 || !balanceAmount ? 0 : balanceAmount)] });
        }
    });
}

export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs })
    data.form = createFormHealthCert({ props, data, refs, isLoading });
    data.rules = createRules({ props, data, refs, isLoading });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    const { routerPrefix } = props
    loadForm({ props, data, refs })
        .then(() => {
            if (props.setAppPageHeader) {
                setAppPageHeader({
                    slots: {
                        top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                        default: () => createAppPageHeaderDefault({ props, data, refs })
                    }
                });
            }
        })
}

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = []
    const col2 = []
    const { menuContext, viewOnly, routerPrefix } = props
    const { useForm } = data
    const { modelRef, initialModel } = useForm
    const { id, isActive } = modelRef
    const canCrate = state.conditionAction.canCreate({ props, record: initialModel })
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel })
    const canSendWait = state.conditionAction.canSendWait({ props, record: initialModel })
    const canSign = state.conditionAction.canSign({ props, record: initialModel })
    const canCancel = state.conditionAction.canCancel({ props, record: initialModel })

    if (id && has({ menuContext, key: 'canCreate' }) && canCrate) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && has({ menuContext, key: 'canView' })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: 'm-1' }))
    }
    if (viewOnly && id && isActive && has({ menuContext, key: 'canEdit' }) && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: 'm-1' }))
    }

    if (!viewOnly && (!id || (id && isActive && canEdit))) {
        let options = null
        col1.push(createButtonSave({
            onClick: () => {
                callFindChildrenByIdAndRequestNo({ requestNo: data.form.requestNo, id: data.form.id }).then(children => {
                    if(!modelRef.refAssignedTo && (initialModel?.refRequestStatus?.key === 'Wait' && modelRef?.refRequestStatus?.key === 'Approve' )) {
                        modelRef.refAssignedTo = store.state.resource.auth.info?.user
                    }
                    if (children.filter(d => !d.isDelete && ["Wait", "Approve"].includes(d?.refRequestStatus?.key)).length) {
                        validateNotification({ message: i18n.global.t('error.form.haveRequestChange')})
                    }
                    else {
                        onClickSave({ props, data, refs })
                    }
                })
            }, classStyle: 'm-1',options
        }))
    }

    if (id && isActive && canSendWait) {
        const statusWait = data.statuses.find(status => status.key === 'Wait')
        col1.push(createButton({
            text: `${viewOnly ? '' : `${i18n.global.t('button.save')} & `}${statusWait?.attribute?.actionText}`,
            classStyle: `m-1 ${statusWait?.attribute?.btnClass}`,
            onClick: () => {
                callFindChildrenByIdAndRequestNo({ requestNo: data.form.requestNo, id: data.form.id }).then(children => {
                    if (children.filter(d => !d.isDelete && ["Wait", "Approve"].includes(d?.refRequestStatus?.key)).length) {
                        validateNotification({ message: i18n.global.t('error.form.haveRequestChange')})
                    } else if (!data.form?.certificateProducts?.filter(d => !d.isDelete).length) {
                        validateNotification({ message: i18n.global.t('error.form.atLeastOneRecord', { key: i18n.global.t('model.samplingProduct.modelName') }), querySelector: '#cardCertificateProducts' })
                    } else if (!data.form?.aquaticScientificNames?.filter(d => !d.isDelete).length) {
                        validateNotification({ message: i18n.global.t('error.form.atLeastOneData', { data: i18n.global.t('model.aquaticScientificName.modelName') }), querySelector: '#divAquaticScientificName' })
                    } else {
                        onClickSave({ props, data, refs, refRequestStatus: statusWait })
                    }
                })
            },
            icon: viewOnly ? null : <CIcon file='save.svg'></CIcon>,
            confirm: {}
        }))
    }

    if (id && isActive && canSign) {
        const statusWaitPrint = data.statuses.find(status => status.key === 'Wait Print')
        const textWaitPrint = `${viewOnly ? '' : `${i18n.global.t("button.save")} & `}${statusWaitPrint?.attribute?.actionText}`
        const statusReject = data.statuses.find(status => status.key === 'Reject')
        const textReject = `${viewOnly ? '' : `${i18n.global.t("button.save")} & `}${statusReject?.attribute?.actionText}`

        col1.push(createButton({
            text: textWaitPrint,
            classStyle: `m-1 ${statusWaitPrint?.attribute?.btnClass}`,
            onClick: () => {
                callFindChildrenByIdAndRequestNo({ requestNo: data.form.requestNo, id: data.form.id }).then(children => {
                    if (children.filter(d => !d.isDelete && ["Wait", "Approve"].includes(d?.refRequestStatus?.key)).length) {
                        validateNotification({ message: i18n.global.t('error.form.haveRequestChange')})
                    } else {
                        onClickSave({ props, data, refs, refRequestStatus: statusWaitPrint })
                    }
                })
            },
            icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
            confirm: { okButtonProps: { class: statusWaitPrint.attribute?.btnClass } }
        }))
        col1.push(createButton({
            text: textReject,
            classStyle: `m-1 ${statusReject?.attribute?.btnClass}`,
            onClick: () => {
                callFindChildrenByIdAndRequestNo({ requestNo: data.form.requestNo, id: data.form.id }).then(children => {
                    if (children.filter(d => !d.isDelete && ["Wait", "Approve"].includes(d?.refRequestStatus?.key)).length) {
                        validateNotification({ message: i18n.global.t('error.form.haveRequestChange')})
                    } else {
                        onClickSave({ props, data, refs, refRequestStatus: statusReject })
                    }
                })
            },
            icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
            confirm: { okButtonProps: { class: statusReject.attribute?.btnClass } }
        }))
    }

    if (id && isActive) {
        data.reports = createReportData({ props, data, refs, modelRef, id: data.form?.id })
        col1.push(createButton({
            text: `${i18n.global.t('components.report.viewReports')}`,
            classStyle: `btn-info m-1`,
            onClick: () => {
                callFindChildrenByIdAndRequestNo({ requestNo: data.form.requestNo, id: data.form.id }).then(children => {
                    if (children.filter(d => !d.isDelete && ["Wait", "Approve"].includes(d?.refRequestStatus?.key)).length) {
                        validateNotification({ message: i18n.global.t('error.form.haveRequestChange')})
                    } else {
                        data.reportModal = openModalReportList({ props, data })
                    }
                })
            },
            icon: <CIcon file='pdf.svg'></CIcon>,
        }))
    }

    if (id && isActive && canCancel) {
        const statusCancel = data.statuses?.find(status => status?.key === "Cancel");
        const userInfo = store.state.resource.auth.info?.user;
        col2.push(
            createButtonCancel({
                options: {text: statusCancel?.attribute?.actionText},
                classStyle: `m-1 ${statusCancel?.attribute?.btnClass}`,
                onClick: record => {
                    Promise.resolve()
                        .then(() => {
                            modelRef.refCanceledBy = userInfo;
                            modelRef.cancelRemark = record?.remark;
                        })
                        .then(() => {
                            callFindChildrenByIdAndRequestNo({ requestNo: data.form.requestNo, id: data.form.id }).then(children => {
                                if (children.filter(d => !d.isDelete && ["Wait", "Approve"].includes(d?.refRequestStatus?.key)).length) {
                                    validateNotification({ message: i18n.global.t('error.form.haveRequestChange')})
                                } else {
                                    onClickSave({ props, data, refs, refRequestStatus: statusCancel });
                                }
                            })
                        });
                }
            })
        );
    }

    if (viewOnly && id && !isActive && has({ menuContext, key: 'canActive' })) {
        col2.push(createButtonActive({ onClick: () => onClickActive({ record: { id }, callActive, setIsLoading: setIsLoadingApp, onClickEdit: () => onClickEdit({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canArchive' })) {
        col2.push(createButtonArchive({ onClick: () => onClickArchive({ record: { id }, callArchive, setIsLoading: setIsLoadingApp, onClickView: () => onClickView({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }

    return <Row type="flex">
        <Col>{col1}</Col>
        <Col class="ml-auto">{col2}</Col>
    </Row>
}

export const createReportData = ({ props, data, refs, modelRef, id }) => {
    const { menuContext, isRequestChangeInformation } = props
    // const canSign = ['Wait Print', 'Printed'].includes(modelRef?.refRequestStatus?.key)
    let statusDraftDoc
    let statusCompleteDoc
    if (has({ menuContext, key: "forCompany" })) {
        statusDraftDoc = ['Draft', 'Wait'].includes(modelRef?.refRequestStatus?.key)
    }

    if (have({ menuContext, key: ["forCertificateApprover", "forCertificateSigner"] })) {
        statusDraftDoc = ['Draft', 'Wait', 'Pending Review', 'Approve'].includes(modelRef?.refRequestStatus?.key) || ( ['Wait Print'].includes(modelRef?.refRequestStatus?.key) && modelRef?.hologramNo2 == null && modelRef?.hologramNo1 == null)
        statusCompleteDoc = ['Wait Print', 'Printed'].includes(modelRef?.refRequestStatus?.key) && (modelRef?.hologramNo2 != null || modelRef?.hologramNo1 != null)
    }

    const canPrintDraftCoverForm = (!modelRef?.isTmp) && (statusDraftDoc || (has({ menuContext, key: "forCompany" }) && !(['Printed'].includes(modelRef?.refRequestStatus?.key))))
    const canPrintCompleteCoverForm = (!modelRef?.isTmp) && (statusCompleteDoc || (has({ menuContext, key: "forCompany" }) && ['Printed'].includes(modelRef?.refRequestStatus?.key)))
    const canPrintDraftHealthCertForm = (!modelRef?.isTmp) && statusDraftDoc
    const canPrintCompleteHealthCertForm = (!modelRef?.isTmp) && statusCompleteDoc
    const canSignCompleteHealthCertForm = (!modelRef?.isTmp) && statusCompleteDoc && has({ menuContext, key: "forCertificateSigner" })
    const canPrintDraftIntransitForm = (!modelRef?.isTmp) && modelRef?.refIntransitForm && statusDraftDoc
    const canPrintCompleteIntransitForm = (!modelRef?.isTmp) && modelRef?.refIntransitForm && statusCompleteDoc
    const canSignCompleteIntransitForm = (!modelRef?.isTmp) && modelRef?.refIntransitForm && statusCompleteDoc && has({ menuContext, key: "forCertificateSigner" })
    const canPrintDraftRequestChangeForm = modelRef?.isTmp && statusDraftDoc
    const canPrintCompleteRequestChangeForm = modelRef?.isTmp && statusCompleteDoc
    const suffix = `-${modelRef?.requestNo}`;
    const suffixRequestChange = `-${modelRef?.requestChangeInformationNo}`;
    return [
        //ตัวอย่าง: ให้เห็นทุกสถานะยกเว้น Printed
        //ฉบับสมบูรณ์: ให้ปริ้นท์ได้เฉพาะตอนที่ทำงานถึงสถานะสุดท้ายแล้ว + มีเลข hologram

        //ใบรายละเอียดผลิตภัณฑ์
        {
            visible: () => isRequestChangeInformation,
            fileName: `คำขอเปลี่ยนแปลง ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
            callReport: () => onClickReport({
                fileName: `คำขอเปลี่ยนแปลง ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
                callReport: () => {
                    const report = state.conditionReport.changeRequestForm({ modelRef });
                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: false } } });
                }
            })
        },
        {
            visible: () => canPrintDraftCoverForm,
            fileName: `(ตัวอย่าง) ใบรายละเอียดผลิตภัณฑ์ ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
            callReport: () => onClickReport({
                fileName: `(ตัวอย่าง) ใบรายละเอียดผลิตภัณฑ์ ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
                callReport: () => {
                    const report = state.conditionReport.coverHealthCertForm();
                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: false } } });
                }
            })
        },
        {
            visible: () => canPrintCompleteCoverForm,
            fileName: `(ฉบับสมบูรณ์) ใบรายละเอียดผลิตภัณฑ์ ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
            callReport: () => onClickReport({
                fileName: `(ฉบับสมบูรณ์) ใบรายละเอียดผลิตภัณฑ์ ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
                callReport: () => {
                    const report = state.conditionReport.coverHealthCertForm();
                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: true } } });
                }
            })
        },

        {
            visible: () => canPrintDraftHealthCertForm,
            fileName: `(ตัวอย่าง) ใบรับรอง ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
            callReport: () => onClickReport({
                fileName: `(ตัวอย่าง) ใบรับรอง ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
                callReport: () => {
                    const report = state.conditionReport.healthCertForm({ modelRef });
                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: false } } });
                }
            }),
        },
        {
            visible: () => canPrintDraftIntransitForm,
            fileName: `(ตัวอย่าง) แบบฟอร์ม In Transit ${modelRef?.refIntransitForm?.value}${suffix}.pdf`,
            callReport: () => onClickReport({
                fileName: `(ตัวอย่าง) แบบฟอร์ม In Transit ${modelRef?.refIntransitForm?.value}${suffix}.pdf`,
                callReport: () => {
                    const report = state.conditionReport.intransitForm({ modelRef });
                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: false } } });
                }
            })
        },
        {
            visible: () => canPrintCompleteHealthCertForm,
            fileName: `(ฉบับสมบูรณ์) ใบรับรอง ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
            callReport: () => onClickReport({
                fileName: `ใบรับรอง ${modelRef?.refRequestForm?.value}${suffix}.pdf`,
                callReport: () => {
                    const report = state.conditionReport.healthCertForm({ modelRef });
                    if (['Wait Print', 'Printed'].includes(modelRef?.refRequestStatus?.key)) {
                        modelRef.isPrinted = true
                        return callCertificateRequestStatus().then(statuses => {
                            const statusPrinted = statuses.filter(status => ["Printed"].includes(status.key))?.[0]
                            modelRef.refRequestStatus = modelRef.isTmp ? modelRef.refRequestStatus : modelRef.refRequestStatus = statusPrinted
                            return callSave({ form: modelRef })
                                .then(res => {
                                    modelRef.version = res.version
                                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: true } } })
                                })
                        })
                    }
                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: true } } })
                }
            }),
            signatureFile: () => modelRef?.signatures?.find(d=>d.documentName === "signature"),
            onSignSignature: !canSignCompleteHealthCertForm ? null : ({ fileModel }) => {
                fileModel.group = "Signature";
                fileModel.name = "signature.png";
                fileModel.documentName = "signature";
                fileModel.isSave = true;
                const index = modelRef.signatures?.findIndex(d=>d.documentName === fileModel.documentName);
                const promises = [data.reportModal?.bind?.onCancel?.()];
                if (index === -1) {
                    promises.push(modelRef.signatures.push(fileModel));
                } else {
                    promises.push(modelRef.signatures[index] = {...modelRef.signatures[index], ...fileModel});
                }
                Promise.all(promises).then(() => onClickSave({ props, data, refs }));
            }
        },
        {
            visible: () => canPrintCompleteIntransitForm,
            fileName: `(ฉบับสมบูรณ์) แบบฟอร์ม In Transit ${modelRef?.refIntransitForm?.value}${suffix}.pdf`,
            callReport: () => onClickReport({
                fileName: `แบบฟอร์ม In Transit ${modelRef?.refIntransitForm?.value}${suffix}.pdf`,
                callReport: () => {
                    const report = state.conditionReport.intransitForm({ modelRef });

                    if (['Wait Print', 'Printed'].includes(modelRef?.refRequestStatus?.key)) {
                        modelRef.isPrinted = true
                        return callCertificateRequestStatus().then(statuses => {
                            const statusPrinted = statuses.filter(status => ["Printed"].includes(status.key))?.[0]
                            modelRef.refRequestStatus = modelRef.isTmp ? modelRef.refRequestStatus : modelRef.refRequestStatus = statusPrinted
                            return callSave({ form: modelRef })
                                .then(res => {
                                    modelRef.version = res.version
                                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: true } } })
                                })
                        })
                    }
                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: true } } })
                }
            }),
            signatureFile: () => modelRef?.signatures?.find(d=>d.documentName === "signature_intransit"),
            onSignSignature: !canSignCompleteIntransitForm ? null : ({ fileModel }) => {
                fileModel.group = "Signature";
                fileModel.name = "signature_intransit.png";
                fileModel.documentName = "signature_intransit";
                fileModel.isSave = true;
                const index = modelRef.signatures?.findIndex(d=>d.documentName === fileModel.documentName);
                const promises = [data.reportModal?.bind?.onCancel?.()];
                if (index === -1) {
                    promises.push(modelRef.signatures.push(fileModel));
                } else {
                    promises.push(modelRef.signatures[index] = {...modelRef.signatures[index], ...fileModel});
                }
                Promise.all(promises).then(() => onClickSave({ props, data, refs }));
            }
        },
        //แบบฟอร์มคำขอเปลี่ยนแปลงข้อมูลใบรับรอง
        {
            visible: () => canPrintDraftRequestChangeForm,
            fileName: `(ตัวอย่าง) แบบฟอร์มคำขอเปลี่ยนแปลงข้อมูลใบรับรอง(${modelRef?.refRequestChangeInformationTopic?.value})${suffixRequestChange}.pdf`,
            callReport: () => onClickReport({
                fileName: `แบบฟอร์มคำขอเปลี่ยนแปลงข้อมูลใบรับรอง(${modelRef?.refRequestChangeInformationTopic?.value})${suffixRequestChange}.pdf`,
                callReport: () => {
                    const report = state.conditionReport.requestChangeForm({ modelRef });
                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: false } } });
                }
            })
        },
        {
            visible: () => canPrintCompleteRequestChangeForm,
            fileName: `(ฉบับสมบูรณ์) แบบฟอร์มคำขอเปลี่ยนแปลงข้อมูลใบรับรอง(${modelRef?.refRequestChangeInformationTopic?.value})${suffixRequestChange}.pdf`,
            callReport: () => onClickReport({
                fileName: `แบบฟอร์มคำขอเปลี่ยนแปลงข้อมูลใบรับรอง(${modelRef?.refRequestChangeInformationTopic?.value})${suffixRequestChange}.pdf`,
                callReport: () => {
                    const report = state.conditionReport.requestChangeForm({ modelRef });
                    if (!modelRef.isPrinted && ['Wait Print', 'Printed'].includes(modelRef?.refRequestStatus?.key)) {
                        modelRef.isPrinted = true
                        setIsLoadingApp(true)
                        callCertificateRequestStatus().then(statuses => {
                            const statusPrinted = statuses.filter(status => ["Printed"].includes(status.key))?.[0]
                            modelRef.refRequestStatus = statusPrinted
                            callSave({ form: modelRef })
                                .finally(() => {
                                    modelRef.version = modelRef.version + 1
                                    return setIsLoadingApp(false)
                                })
                        })
                    }
                    return callJasperReportByKey({ data: { ...report, attribute: { id, isSign: true } } });
                }
            })
        },
    ]
}

export const loadDefaultForm = ({ data }) => {
    const promises = []
    promises.push(Promise.all([ callCertificateRequestStatus() ])
        .then(arr => {
            data.statuses = arr[0]
        }))
    return Promise.all(promises)
}

export const onClickSave = ({ props, data, refs, refRequestStatus }) => {
    const { viewOnly, routerPrefix } = props
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true)
            return callSave({ form: refRequestStatus ? { ...data.useForm.modelRef, refRequestStatus } : data.useForm.modelRef })
                .finally(() => setIsLoadingApp(false))
                .then((record) => {
                    if (viewOnly) initForm({ props, data, refs })
                    else onClickView({ record, routerPrefix })
                })
        })
        .catch((error) => {
            validateError({ error })
            throw error
        });
}

export const initState = ({ props }) => {
        const { menuContext, routerPrefix } = props
        state.columns = createColumns({ props }),
            state.manages = [
                createManageSelect({ menuContext }),
                createManageActive({
                    menuContext,
                    onClick: ({ rowSelection }) => onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
                }),
                createManageArchive({
                    menuContext,
                    onClick: ({ rowSelection }) => onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
                }),
                createManageDelete({
                    menuContext,
                    getCheckboxProps: ({ record }) => ({ disabled: ['Pending Review', 'Approve', 'Wait Print', 'Printed'].includes(record?.refRequestStatus?.key) }),
                    onClick: ({ rowSelection }) => onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
                }),
                createManageExportCsv({ menuContext }),
                {
                    icon: () => <CIcon file="add-curve.svg"></CIcon>,
                    text: () => i18n.global.t("button.reserve"),
                    force: false,
                    visible: () => has({ menuContext: menuContext, key: "canReserve" }),
                    rowSelection: true,
                    confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.name).join(", ") }),
                    buttonProp: { class: "btn-primary" },
                    getCheckboxProps: ({ record }) => ({ disabled: record.isActive === false }),
                    onClick: ({ rowSelection }) => {
                        setIsLoading(true)
                        callCertificateRequestStatus().then(status => {
                            const statusPendingReview = status.find(status => status.key === 'Pending Review')
                            rowSelection.selectedRows.forEach(d => {
                                d.refAssignedTo = store.state.resource.auth.info?.user
                                d.refRequestStatus = statusPendingReview
                            })
                            return callSaveAll({ form: rowSelection.selectedRows })
                                .then(() => {
                                    state.page.page = 0;
                                    onSearch({ props, ...state});
                                })
                                .finally(() => setIsLoading(false));
                        })
                    },
                },
                {
                    icon: () => <CIcon file="cancel.svg"></CIcon>,
                    text: () => i18n.global.t("button.cancelReserve"),
                    force: false,
                    visible: () => has({ menuContext: menuContext, key: "canCancelReserve" }) ,
                    rowSelection: true,
                    confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.name).join(", ") }),
                    buttonProp: { class: "btn-danger" },
                    getCheckboxProps: ({ record }) => ({ disabled: record.isActive === false || ['Approve', 'Wait Print', 'Printed'].includes(record?.refRequestStatus?.key)}),
                    onClick: ({ rowSelection }) => {
                        setIsLoading(true)
                        callCertificateRequestStatus().then(status => {
                            const statusWait = status.find(status => status.key === 'Wait')
                            rowSelection.selectedRows.forEach(d => {
                                d.refAssignedTo = null
                                d.refRequestStatus = statusWait
                            })
                            return callSaveAll({ form: rowSelection.selectedRows })
                                .then(() => {
                                    state.page.page = 0;
                                    onSearch({ props, ...state});
                                })
                                .finally(() => setIsLoading(false));
                        })
                    },
                },
            ]
        state.manageExtras = []
        if(!props.isTmp) {
            state.manageExtras.push(
                createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })
            )
        } else {
            state.manageExtras.push(
                createManageExtraCreate({ menuContext,
                    onClick: () => openModalCreateRequestChangeHealthCertificateInformation({ props }),
                })
            )
        }
        state.rowActions = [
            createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
            createRowActionEdit({
                menuContext,
                onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
                visible: ({ record }) => state.conditionAction.canEdit({ props, record }),
            }),
        ]
}

export const copyForm = ({ form }) => {
    form = lodash.cloneDeep(form);
    form.id = null;
    form.version = null;
    form._id = randomUuid();
    return lodash.cloneDeepWith(form, value => {
        if (Array.isArray(value)) {
            return value.forEach(value2 => {
                if(typeof value2 === 'object'){
                    value2._oldId = lodash.cloneDeep(value2.id);
                    value2.id = null;
                    value2.version = null;
                    value2._id = randomUuid();
                }
            });
        }
    });
};

export const state = reactive({
    page: createPage({
        options: {
            select: ['**', 'refCompany.refFactoryAddrEn.**', 'refExportCountry.**'],
            sort: [{ name: "refCompany.thNo", type: "ASC" }],
            children: [
                { name: 'attachments', select: ['*'], page: 0, size: 1000000},
                { name: 'farmLocations', select: ['*'], page: 0, size: 1000000},
                { name: 'aquaticScientificNames', select: ['*', 'refScientificType.*'], page: 0, size: 1000000 },
                { name: 'certificateProducts',
                    select: [
                        '**',
                        'refCompanyProduct.refProduct.*',
                        'refCompanyProduct.refProduct.refProductType.*',
                        'refSamplingProduct.*',
                        'refSamplingProduct.refExportAmountUnit.*',
                        'refSamplingProduct.refCompanyProduct.*',
                        'refSamplingProduct.refCompanyProduct.refProduct.*',
                        'refSamplingProduct.refCompanyProduct.refProduct.refProductType.*',
                        'refSamplingProduct.refCountry1.refCountry.*',
                        'refSamplingProduct.refCountry2.refCountry.*',
                        'refParent.**',
                        'refParent.refCompanyProduct.refProduct.*',
                        'refParent.refCompanyProduct.refProduct.refProductType.*',
                        'refParent.refSamplingProduct.*',
                        'refParent.refSamplingProduct.refExportAmountUnit.*',
                        'refParent.refSamplingProduct.refCompanyProduct.*',
                        'refParent.refSamplingProduct.refCompanyProduct.refProduct.refProductType.*',
                        'refParent.refSamplingProduct.refCountry1.refCountry.*',
                        'refParent.refSamplingProduct.refCountry2.refCountry.*',
                    ],
                    page: 0,
                    size: 1000000,
                },
                { name: 'children', select: ['**'], page: 0, size: 1000000},
            ]
        }
    }),
    tableOptions: { search: { activeKey: 'Search' } },
    conditionAction: createConditionAction(),
    conditionReport: createConditionReport(),
})

// todo: แก้ชื่อ route ของคำขอเปลี่ยนแปลง
// todo: ปิด field ของคำขอยกเลิกไม่ต้องให้เค้ากรอกข้อมูล